import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {ShopCreature} from "@/store/shop/types";
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";

export class ValuteHeroPanel extends ShopCreaturePanel {

    protected getPriceText(sc: ShopCreature): string {
        if (sc.bankOption && sc.bankOption.valuteName && sc.bankOption.valuteName.length > 0) {
            return TextUtils.formatGems(sc.bankOption.price) + " " + sc.bankOption.valuteName;
        }
        return TextUtils.formatGems(sc.price);
    }

    protected getBtnIcAtlas(): string | undefined {
        return Keys.ATLAS_PROFILE;
    }

    protected getBtnIcImg(): string {
        return Keys.UI_GOLDEN_CHECK;
    }

    protected getPriceTextDiscount(): number {
        return 15;
    }

    protected getPriceTextNoDiscount(): number {
        return 14;
    }
}